import { useUiStore } from '../../../store/uiStore';
import { useHasAccessToSchedules } from './useHasAccessToSchedules';
import { MissionTab } from '../../../consts/missionTab';

export const useSelectedMissionsTab = () => {
  const { selectedMissionsTab } = useUiStore();
  const hasAccessToSchedules = useHasAccessToSchedules();

  if (selectedMissionsTab) {
    return selectedMissionsTab;
  }

  return hasAccessToSchedules && !window.location.hash.startsWith('#p-')
    ? MissionTab.Schedules
    : MissionTab.AllProjects;
};
